// extracted by mini-css-extract-plugin
module.exports = {"deviceMainContent":"_slug__deviceMainContent__01p2S"};